













































































































import AddButton from '@/components/AddButton.vue'
import Table from '@/components/Table.vue'
import { generateTopUpInvoice, getTopUps } from '@/api/Topup/topup.api'
import { TableHeader, Params } from '@/utils/interfaces'
import { AsYouType } from 'libphonenumber-js'
import ActionButton from '@/components/ActionButton.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { GetTopUpDTO, TopUpAgent } from '@/utils/interfaces/topup.interface'
import { chipClasses } from '@/utils/chipClasses.constant'
import TopUpDetails from '@/components/Services/TopUps/TopUpDetails.vue'
import TitleButton from '@/components/TitleButton.vue'
import HistoryDialog from '@/components/Services/TopUps/HistoryDialog.vue'
import { formatDate } from '@/utils/functions'
import mixins from 'vue-typed-mixins'
import { reportMixin } from '@/utils/mixins/reportMixin'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TreeviewButton from '@/components/Services/TopUps/TreeviewButton.vue'
import { productsEnum } from '@/utils/productsCode.constant'
import NautaFilter from '@/components/Services/Nauta/NautaFilter.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default mixins(reportMixin, tableHandler<GetTopUpDTO>()).extend({
  components: {
    appAddButton: AddButton,
    appTable: Table,
    appNautaFilter: NautaFilter,
    appActionButton: ActionButton,
    appTopUpDetails: TopUpDetails,
    appTitleButton: TitleButton,
    appHistoryDialog: HistoryDialog,
    appConfirmDialog: ConfirmDialog,
    appTreeviewButton: TreeviewButton,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      createDialogModel: false,
      historyDialog: false,
      loadingInvoice: false,
      key: 0,
      headers: [
        {
          text: this.$t('details'),
          value: 'details',
        },
        {
          text: this.$t('client-name'),
          value: 'client',
        },
        {
          text: this.$t('email'),
          value: 'destination_account',
        },
        {
          text: this.$t('agent'),
          value: 'from_agent_name',
        },
        {
          text: this.$t('amount') + ' ($)',
          value: 'amount',
        },
        {
          text: this.$t('created-at'),
          value: 'created_at',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
      ] as TableHeader[],
      getter: (params?: Params) => {
        const newParams = {
          ...params,
          topup__product__code: productsEnum.Nauta,
        }
        if (this.$store.getters.profile.role === 'ADMIN') {
          return getTopUps({
            integration: false,
            chain_type: 'AGENCY',
            ...newParams,
          })
        } else
          return getTopUps({
            ...newParams,
          })
      },
      chipClasses: chipClasses,
      historyItem: null as null | GetTopUpDTO,
      reviewItem: null as null | GetTopUpDTO,
      loadingReport: false,
      confirmDialog: false,
      loadingConfirm: false,
      loadingRefresh: false,
      loadingAgent: false,
      agent: {} as TopUpAgent,
      action: '',
    }
  },
  methods: {
    async onGenerateInvoice(value: boolean) {
      try {
        this.loadingInvoice = true
        const response = await generateTopUpInvoice({
          ...this.table.lastFilter,
          ['show-cost']: value,
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = 'invoices.pdf'
        link.click()
      } finally {
        this.loadingInvoice = false
      }
    },
    async getReport() {
      try {
        this.loadingReport = true
        await this.generateReport(this.table.lastFilter)
      } finally {
        this.loadingReport = false
      }
    },
    formatDate(date: string): string {
      return formatDate(date)
    },
    asYouType(value: string) {
      return new AsYouType().input(value)
    },
    async refresh() {
      try {
        this.loadingRefresh = true
        await this.newFilter(this.table.lastFilter)
      } finally {
        this.loadingRefresh = false
      }
    },
    onHistory(item: GetTopUpDTO) {
      this.historyItem = item
      this.historyDialog = true
    },
  },
  created() {
    if (this.$store.getters.profile.role === 'ADMIN') {
      this.headers.splice(3, 0, {
        text: this.$t('provider'),
        value: 'provider',
      })
    }
    if (this.$store.getters.profile.is_superuser) {
      this.headers.splice(4, 1, {
        text: this.$t('created_by'),
        value: 'created_by',
      })
    }
  },
})
